import { useMutation } from "@tanstack/react-query";

import { getUserByEmail } from "~/api";

export const useGetUserByEmail = () => {
  return useMutation({
    mutationFn: (email: string) => getUserByEmail(email),
    retry: false,
  });
};
